import { NgModule } from '@angular/core';

import { SharedModule } from "../../shared/shared.module";
import { CorApiService } from "./cor-api.service";

@NgModule({
  imports: [
    SharedModule
  ],
  providers:[
    CorApiService
  ],
  declarations: []
})
export class CoresModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/cores/cores.module.ts
 **/